import { render, staticRenderFns } from "./Auction.vue?vue&type=template&id=420a0e0b&scoped=true&"
import script from "./Auction.vue?vue&type=script&lang=ts&"
export * from "./Auction.vue?vue&type=script&lang=ts&"
import style0 from "./Auction.vue?vue&type=style&index=0&id=420a0e0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a0e0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VIcon,VPagination})
